import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
export function WhatsIncluded() {
  const items = ['El sistema completo Mapa 3D explicado simple', 'Tablas por edad (0–18 meses) para ventanas de vigilia', 'Ritual de 12 minutos (mínimo viable, repetible)', 'Escalera de ayuda nocturna (qué hacer primero)', 'Tarjetas imprimibles de guiones 2am', "Plan 'Reset en 7 días' (qué cambiar cada día)", 'Solución a problemas típicos: falsos inicios, 5am club', 'Bitácora 3D para medir progreso sin obsesionarte'];
  return <section className="py-20 px-4 bg-[#0c1425]" data-id="element-152">
      <div className="max-w-4xl mx-auto" data-id="element-153">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-154">
          <h2 className="text-3xl md:text-4xl font-serif text-cream mb-12 text-center" data-id="element-155">
            Lo que vas a recibir dentro de <br data-id="element-156" />
            <span className="text-gold-gradient" data-id="element-157">"Noches en Paz"</span>
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-158">
            {items.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-start p-4 bg-[#1a2744]/50 rounded-xl border border-white/5 hover:bg-[#1a2744] transition-colors" data-id="element-159">
                <CheckCircle className="w-6 h-6 text-amber-500 mr-4 shrink-0 mt-0.5" data-id="element-160" />
                <span className="text-amber-50/90 text-lg" data-id="element-161">{item}</span>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}